import { AppBar, Toolbar, Button, Box, Menu, MenuItem } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import useListStore from '../../store/useListStore'
import logoImage from '../../assets/images/logo@3x.webp'
import React, { useState } from 'react'
import { accessFileUrl } from '../../services/axios/functions/list.function'
const Navbar = ({ fileUrl = '', sscc, po }: { fileUrl: string; sscc: string; po: string }) => {
  const navigate = useNavigate()
  const { setDetails, setIds, setList, setFullData } = useListStore()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleVerifyClick = () => {
    navigate('/')
    sessionStorage.clear()
    setDetails(undefined)
    setIds(undefined)
    setList(undefined)
    setFullData(null)
  }

  const handleDownload = async () => {
    try {
      const response = await accessFileUrl(sscc, po)
      if (response?.data?.fileUrl) {
        window.location.assign(response.data.fileUrl)
      }
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  return (
    <>
      {/* <AppBar position="fixed" style={{ backgroundColor: "#00529B" }}> */}
      <AppBar
        position="relative"
        sx={{ bgcolor: 'primary.dark' }}
        style={{ justifyContent: 'center' }}
      >
        <Toolbar
          sx={{
            '@media (min-width: 0px)': { paddingLeft: 0 },
          }}
        >
          {/* Logo Image */}
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            // component={Link}
            // to="/dashboard"
            sx={{
              marginRight: 'auto',
              textDecoration: 'none',
              position: 'relative',
              ml: '-60px',
              px: { xs: 3, md: 4 },
              py: 1,
              width: { xs: '300px', md: '320px' },
            }}
          >
            <img
              src={logoImage}
              alt="LifeScience Logistics"
              style={{
                height: '58px',
                position: 'relative',
                zIndex: 2,
                width: 'auto',
              }}
            />
            <Box
              sx={{
                width: '100%',
                height: '100%',
                // marginLeft: { xs: '-10px', sm: '-20px' },
                position: 'absolute',
                left: 0,
                top: 0,
              }}
            >
              <Box
                sx={{
                  bgcolor: 'primary.main',
                  height: '100%',
                  width: '100%',
                  clipPath: 'polygon(0 0, 78% 0%, 100% 100%, 20% 100%)',
                  position: 'relative',
                }}
              />
              <Box
                sx={{
                  bgcolor: 'black',
                  height: '100%',
                  top: 0,
                  left: '50%',
                  translate: '-50% 0 0',
                  width: '100%',
                  clipPath: 'polygon(5% 0, 72% 0%, 94% 100%, 28% 100%)',
                  position: 'absolute',
                }}
              />
              <Box
                sx={{
                  bgcolor: 'white',
                  height: '100%',
                  top: 0,
                  left: '50%',
                  translate: '-50% 0 0',
                  width: '100%',
                  clipPath: 'polygon(12% 0, 65% 0%, 87% 100%, 35% 100%)',
                  position: 'absolute',
                }}
              />
            </Box>
          </Box>

          {/* Clip Path */}

          {/* Navigation Links */}
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              gap: { md: 3 },
            }}
          >
            <Button
              onClick={handleDownload}
              style={{
                fontFamily: 'Atlas-Typewriter-Light',
                fontWeight: 300,
                letterSpacing: 1.25,
                fontSize: '1rem',
                display: 'inline-flex',
                alignItems: 'center',
                minWidth: '64px',
                color: '#fff',
                opacity: !fileUrl || fileUrl === '' ? 0.5 : 1,
                padding: '6px 16px',
                lineHeight: '1.76px',
                textDecoration: 'none',
                textTransform: 'uppercase',
              }}
              disabled={!sscc || !po}
            >
              {' '}
              Download EPCIS File{' '}
            </Button>
            <Button
              color="inherit"
              onClick={handleVerifyClick}
              sx={{
                fontFamily: 'Atlas-Typewriter-Light',
                fontWeight: 300,
                letterSpacing: 1.25,
                fontSize: '1rem',
              }}
            >
              Verify Another SSCC
            </Button>
          </Box>
          <Button
            data-testid="menu-button"
            id="demo-positioned-button"
            aria-controls={open ? 'demo-positioned-menu' : undefined}
            aria-haspopup={true}
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{
              display: { xs: 'flex', sm: 'none' },
            }}
          >
            <svg fill="none" height="32" viewBox="0 0 20 20" width="32">
              <path
                d="m9 15c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.55228 0-1-.4477-1-1zm-6-10c0-.55229.44771-1 1-1h12c.5523 0 1 .44771 1 1 0 .55228-.4477 1-1 1h-12c-.55229 0-1-.44772-1-1zm0 5c0-.55228.44771-1 1-1h12c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1h-12c-.55229 0-1-.4477-1-1z"
                fill="rgb(256,256,256)"
              ></path>
            </svg>
          </Button>
          <Menu
            data-testid="menu-close"
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            style={{
              top: '2.5rem',
            }}
          >
            <MenuItem
              onClick={handleDownload}
              style={{
                border: '1px solid',
                borderColor: 'primary',
                borderRadius: '6px',
                margin: '0px 8px',
              }}
              sx={{
                transition: 'color 0.3s', // Optional: adds smooth transition
                '&:hover': {
                  color: 'primary',
                  cursor: 'pointer',
                },
              }}
              disabled={!sscc || !po}
            >
              Download EPCIS File
            </MenuItem>
            <MenuItem
              onClick={handleVerifyClick}
              style={{
                border: '1px solid',
                borderColor: 'primary',
                borderRadius: '6px',
                margin: '12px 8px 0px 8px',
              }}
            >
              Verify Another SSCC
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Navbar
